import { VALIDATION_MSGS } from "./constants";

export const validateContactNumber = (value) => {
    let errors = [];
    if (!value || !value.length) errors.push(VALIDATION_MSGS.REQUIRED);
    if (value.length !== 10) errors.push(VALIDATION_MSGS.INVALID_CONTACT_NUMBER);
    return errors;
};